var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInternshipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 13.6001V17.8001C9.8 17.8001 11.2 19.2001 14 19.2001C16.8 19.2001 18.2 17.8001 18.2 17.8001V13.6001",
    stroke: "#172B4D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.95 17.4501L18.9453 19.7905C18.7858 20.1619 19.0674 20.6001 19.48 20.6001H20.42C20.8326 20.6001 21.1142 20.1619 20.9547 19.7905L19.95 17.4501ZM19.95 17.4501V12.55",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.916 8.00617C11.8965 8.29922 8.83685 10.0191 7.3239 10.9317C6.89203 11.1922 6.89203 11.8078 7.3239 12.0683C8.83685 12.9809 11.8965 14.7008 13.916 14.9938C13.9727 15.002 14.0273 15.002 14.084 14.9938C16.1036 14.7008 19.1631 12.9809 20.6761 12.0683C21.108 11.8078 21.108 11.1922 20.6761 10.9317C19.1631 10.0191 16.1036 8.29922 14.084 8.00617C14.0273 7.99794 13.9727 7.99794 13.916 8.00617Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternshipIcon);
export default __webpack_public_path__ + "static/media/internship_icon.aec0ff0d1ac1e057ae1403015bfb0fc7.svg";
export { ForwardRef as ReactComponent };